'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RULE = exports.RULE = 'rule';
var WORD = exports.WORD = 'word';
var ALTERNATIVE = exports.ALTERNATIVE = 'alt';


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/types.js
// module id = 91
// module chunks = 0